<mat-toolbar>
  <h1>Reports</h1>
  <button mat-button [routerLink]="['/home/timesheet-report/user']">
    User Report
  </button>

  <button mat-button [routerLink]="['/home/timesheet-report/category']">
    Category Report
  </button>
  <span class="example-spacer"></span>
</mat-toolbar>
@if(isCategoryReport) {
  <app-category-report></app-category-report>
}
@else if (isUserReport) {
  <app-user-report></app-user-report>
}
<router-outlet></router-outlet>
